module.exports = __webpack_public_path__ + "static/media/activity-video.2110d592.png";